export default String.raw`
.promoBanner2 {
    .timer {
        gap: 8px 0;

        &--position {
            margin-top: 24px;
        }

        .countdown {
            gap: 0 8px;
        }
    }

    &__label {        
        &::after {
            content: 'Tablet';
        }
    }
}
`